import { Component} from '@angular/core';
import {
  AlertController, App, LoadingController, ModalController, NavController, NavParams,
  Platform,
  ToastController, ViewController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import { Storage } from '@ionic/storage';
import {FeesDetailsPage} from "../fees-details/fees-details";


@Component({
  selector: 'page-fees',
  templateUrl: 'fees.html',
})
export class FeesPage {

  FUserId:any;
  UserRights:any;
  Item:any;
  StudentFormNo:any;
  StudentId:any;
  SchoolId:any;
  SpareFees:any;
  FeesData:any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public service: ServiceProvider,
              public platform:Platform,
              public loadingCtrl: LoadingController,
              public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              public modalCtrl: ModalController,
              public alertCtrl: AlertController,
              public viewCtrl: ViewController) {

    Promise.all([this.storage.get('LoginData'),this.storage.get('UserData')]).then(values => {
      console.log(values);
      this.FUserId = values[0]['FUserId'];
      this.Item = navParams.get('item');
      this.StudentFormNo=this.Item.StudentFormNo;
      this.StudentId=this.Item.StudentId;
      this.SchoolId=navParams.get('SchoolId');
      console.log("Data -> ",this.Item);
      this.get_user_rights(this.FUserId);

      this.loadValues(this.SchoolId,this.StudentId);

    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FeesPage');
  }

  get_user_rights(FUserId){
    this.service.httpcall('web_service/get_users_rights?FUserId='+FUserId).subscribe(data => {
      console.log(data['RightsData']);
      this.UserRights = data['RightsData'];
      if(this.UserRights != undefined){
        // console.log(this.School)
        // this.active_tab(this.School);
      }
    })
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  loadValues(SchoolId,StudentId){
    this.service.httpcall('app_web_service/get_student_fees_details_school_Id?FUserId='+this.FUserId+'&StudentId='+StudentId+'&SchoolId='+SchoolId).subscribe(data => {
      console.log(data);
      if(data['response']=="success"){
        this.SpareFees=data['Data']['SpareFees'];
        this.FeesData=data['FeesData'];
      }else{
        this.showAlert(data['error_description'],data['response']);
      }
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.loadValues(this.SchoolId,this.StudentId);
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }

  showAlert(msg,title) {
    const alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['close']
    });
    alert.present();
  }

  go_to_feesDetail(item){
    // console.log('click');
    let Data={
      'FAcademicYearId':item.Id,
      'AcademicYear':item.AcademicYear,
      'StudentFormNo':this.StudentFormNo,
      'StudentId':this.StudentId,
      'SchoolId':this.SchoolId
    }
    let FeesModel = this.modalCtrl.create(FeesDetailsPage,{feesdata:Data});
    FeesModel.onDidDismiss(data => {
      console.log(data);
      if( data == undefined){

      }else{

      }
    });
    FeesModel.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/fees/fees.ts